<template>
    <div>
        <div class="header-card d-flex justify-content-start align-items-center mb-4 p-3 rounded shadow-sm">
            <Backlink :back="{ name: 'catalogues.index' }" />
             
            <div class="ms-3">
                <h2 class="mb-1">{{ id ? 'Modifier le catalogue' : 'Nouveau catalogue' }}</h2>
                <small class="text-muted">{{ id ? 'Modifiez les informations du catalogue' : 'Créez un nouveau catalogue' }}</small>
            </div>
            <!-- <button class="btn btn-outline-secondary" @click="$router.push({ name: 'catalogues.index' })">
                <i class="bi bi-arrow-left me-1"></i>Retour
            </button> -->
        </div>

        <div class="row justify-content-center">
            <div class="col">
                <div class="shadow-sm">
                        <CatalogueForm @saved="goToCatalogue" @edited="goToCatalogue" :item="catalogue"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CatalogueForm from "@/components/forms/CatalogueForm.vue";
import Backlink from "@/components/partials/Backlink.vue";

export default {
    name: 'CatalogCreate',
    components: { CatalogueForm, Backlink },
    props: {
        id: {
            type: [String, Number],
            default: null,
        }
    },
    data() {
        return {
            catalogue: null,
        }
    },

    methods: {
        goToCatalogue() {
            this.$router.push({ name: 'catalogues.index'});
        },
        getCatalogue() {
            if (this.id) {
                this.$api.get(`/catalogs/${this.id}`)
                    .then(response => {
                        this.catalogue = response.data.data;
                    })
                    .catch(error => {
                        console.error('There was an error fetching the catalogue!', error);
                    });
            }
        }   
    },
    created() {
        this.getCatalogue();
    }
}

</script>